import React from "react";
import { Card, FormLabel, Grid, Stack, Tooltip } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import { Series } from "../Dashboard/Dashboard";
import BarChart from "../Charts/BarChart";
import DonutChart from "../Charts/DonutChart";

export type DashboardItems = {
  mitigation_rate: number;
  annual_time_lost?: number;
  total_time_saved?: number;
  impact_score?: number;
  time_to_impact?: number;
  solutions: {
    approved: number;
    series: Series[];
  };
}

const SolutionDashboard = (props: { items?: DashboardItems }) => {

  return <Grid id="dashboard" container spacing={3}>

    <Grid size={{xs: 12, md: 3}}>
      <Card>
        <h3>Solutions</h3>
        <h2 className='text-light'>{typeof(props.items?.solutions?.approved) !== "undefined" ? props.items?.solutions.approved : '-'} <FormLabel><span className="text-secondary">delivered</span></FormLabel></h2>
        <div className='area-chart'>{<BarChart series={props.items?.solutions?.series ?? []} />}</div>
      </Card>
    </Grid>

    <Grid size={{xs: 12, md: 3}}>
      <Card>
        <h3>Total time saved</h3>
        <h2 className='text-light'>{typeof(props.items?.total_time_saved) !== "undefined" ? Math.round(props.items.total_time_saved / 60 * 100) / 100 : '-'} <FormLabel><span className="text-secondary">h</span></FormLabel></h2>
      </Card>
    </Grid>

    <Grid size={{xs: 12, md: 3}}>
      <Card>
        <h3>Impact score<Tooltip title={<span>&lt;1 = more time lost than saved<br />&gt;1 = more time saved than lost</span>} sx={{ml: 0.5}}><InfoIcon color="secondary" fontSize="small" /></Tooltip></h3>
        <div className='area-chart'>{<DonutChart series={[props.items?.annual_time_lost ?? 0, props.items?.total_time_saved ?? 0]} score={props.items?.impact_score} />}</div>
      </Card>
    </Grid>
    
    <Grid size={{xs: 12, md: 3}}>
      <Card>
        <FormLabel>Time to impact<Tooltip title="Average days from lesson capturing to resolved solution." sx={{ml: 0.5}}><InfoIcon color="secondary" fontSize="small" /></Tooltip></FormLabel>
        <Stack direction="row" alignItems="center" gap={2}>
          <h3 className='text-light'>{props.items?.time_to_impact ? <>{props.items.time_to_impact} <FormLabel><span className="text-secondary">days</span></FormLabel></> : <FormLabel><span className="text-secondary">Not enough data</span></FormLabel>}</h3>
        </Stack>

        <FormLabel sx={{mt: 2}}>Mitigation rate<Tooltip title="Amount of lessons learned that got into a solution process." sx={{ml: 0.5}}><InfoIcon color="secondary" fontSize="small" /></Tooltip></FormLabel>
        <Stack direction="row" alignItems="center" gap={2}>
          <h3 className='text-light'>{typeof(props.items?.mitigation_rate) !== "undefined" ? props.items.mitigation_rate : '-'} <FormLabel><span className="text-secondary">%</span></FormLabel></h3>
        </Stack>
      </Card>
    </Grid>

  </Grid>
};

export default SolutionDashboard;
